---
fr:
  errors:
    invalid_number: Saisissez un nombre valide
